<template>
  <doc-table :techCode="techCode" :orderCode="orderCode" :disabled="disabled" />
</template>
<script>
import DocTable from './components/table/index'
export default {
  components: { DocTable },
  props: {
    orderCode: { type: String, default: '' },
    techCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>
